import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [LIST_CHANCES, LIST_CHANCES_SUCCESS, LIST_CHANCES_FAILURE] =
  createRequestActionTypes('chance/LIST_CHANCES');
export const listChances = createAction(
  LIST_CHANCES,
  (searchData) => searchData,
);
const listChancesSaga = createRequestSaga(LIST_CHANCES, chanceApi.getChances);

export function* chancesSaga() {
  yield takeLatest(LIST_CHANCES, listChancesSaga);
}

const initialState = {
  chances: null,
  error: null,
};

const chances = handleActions(
  {
    [LIST_CHANCES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      chances: data.list.map((chance) => ({
        id: chance.prjUuid,
        prjSeq: chance.prjSeq,
        prjUuid: chance.prjUuid,
        prjNo: chance.prjNo,
        cstNm: chance.cstNm,
        cstStatus: chance.cstStatus,
        cstGrade: chance.cstGrade,
        prjTyp: chance.prjTyp,
        partnerInc: chance.partnerInc,
        chargeNm: chance.chargeNm,
        chargeEml: chance.chargeEml,
        chargeTel: chance.chargeTel,
        chanceTyp: chance.chanceTyp,
        prjImpt: chance.prjImpt,
        bugetYn: chance.bugetYn,
        partnerTyp: chance.partnerTyp,
        incTyp: chance.incTyp,
        solutionTyp: chance.solutionTyp,
        productYn: chance.productYn,
        vendorCmp: chance.vendorCmp,
        vendorCmpNm: chance.vendorCmpNm,
        vendorEmp: chance.vendorEmp,
        vendorEmpNm: chance.vendorEmpNm,
        expBenefitRate: chance.expBenefitRate,
        expSales: chance.expSales,
        expBuy: chance.expBuy,
        expDay: chance.expDay,
        // pmUsr: chance.pmUsr,
        // pmNm: chance.pmNm,
        // plUsr: chance.plUsr,
        // plNm: chance.plNm,
        // techUsr: chance.techUsr,
        // techNm: chance.techNm,
        costYn: chance.costYn,
        mtnFreeTor: chance.mtnFreeTor,
        mtnPayTor: chance.mtnPayTor,
        mtnFreeSt: chance.mtnFreeSt,
        mtnFreeEd: chance.mtnFreeEd,
        mtnPaySt: chance.mtnPaySt,
        mtnPayEd: chance.mtnPayEd,
        totalPurchase: chance?.totalPurchase,
        totalSales: chance?.totalSales,
        totalProfit: chance?.totalProfit,
        totalMargin: chance?.totalMargin,
        useYn: chance.useYn,
        crtDptNm: chance.crtDptNm,
        crtNm: chance.crtNm,
        crtGradeNm: chance.crtGradeNm,
        crtDt: chance.crtDt,
        cngNm: chance.cngNm,
        cngDt: chance.cngDt,
      })),
      error: null,
    }),
    [LIST_CHANCES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
  },
  initialState,
);

export default chances;
